import React from "react";
import { useNavigate } from "react-router-dom";

export default function ContactsHub() {
  const navigate = useNavigate();

  const items = [
    {
      title: "Customers",
      description: "Manage client directories, company details, GST records, and primary contacts.",
      route: "/customers",
      icon: "groups",
      color: "bg-blue-100 text-blue-700",
    },
    {
      title: "ABB Warranty Complaints",
      description: "Manage ABB customer warranty calls, addresses, contacts, and attended engineers directly.",
      route: "/admin/abb-warranty-complaints",
      icon: "verified",
      color: "bg-teal-100 text-teal-700",
    },
    {
      title: "Suppliers (Dealers)",
      description: "Access vendor profiles, trading items, purchase histories, and suppliers contacts.",
      route: "/admin/dealers",
      icon: "store",
      color: "bg-indigo-100 text-indigo-700",
    },
    {
      title: "Engineers",
      description: "Manage engineer accounts, tracking settings, and site performance metrics.",
      route: "/engineers",
      icon: "engineering",
      color: "bg-emerald-100 text-emerald-700",
    },
    {
      title: "Accounts Personnel",
      description: "Set up and manage logins and custom role settings for the accounting staff.",
      route: "/admin/accounts",
      icon: "manage_accounts",
      color: "bg-amber-100 text-amber-700",
    },
    {
      title: "Accounts Monitor",
      description: "Audit action trails and system logs generated by the accounting department.",
      route: "/admin/accounts-monitor",
      icon: "monitor_heart",
      color: "bg-cyan-100 text-cyan-700",
    },
    {
      title: "Website Enquiries",
      description: "Review contact forms, requests, and queries from the public homepage.",
      route: "/admin/website-enquiries",
      icon: "mail",
      color: "bg-orange-100 text-orange-700",
    },
  ];

  return (
    <div className="space-y-6">
      <div>
        <span className="font-label-caps text-[11px] text-primary uppercase mb-1 block">ADMIN WORKSPACE</span>
        <h1 className="font-headline-lg text-headline-lg text-on-surface">Contacts</h1>
        <p className="text-sm text-outline mt-1">Select a database to view directory profiles, logs, and public site inquiries.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((item) => (
          <button
            key={item.route}
            onClick={() => navigate(item.route)}
            className="bg-white p-6 rounded-2xl border border-slate-200 shadow-sm hover:shadow-md hover:border-primary/30 transition-all text-left flex items-start gap-4 active:scale-[0.98] w-full"
          >
            <div className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 ${item.color}`}>
              <span className="material-symbols-outlined text-2xl">{item.icon}</span>
            </div>
            <div className="flex-1 space-y-1">
              <h3 className="text-base font-bold text-on-surface flex items-center justify-between">
                {item.title}
                <span className="material-symbols-outlined text-outline-variant text-sm group-hover:text-primary">arrow_forward</span>
              </h3>
              <p className="text-sm text-outline leading-relaxed">{item.description}</p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
